import React from 'react';
import {
  Alert, AlertTitle, Box, Button, CircularProgress, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useInventoryQueueRegistry } from '../hooks/useInventoryQueueRegistry';

export default function InventoryStorageGuard({ children }) {
  const { t } = useTranslation();
  const queue = useInventoryQueueRegistry();
  if (queue?.storageStatus === 'ready') return children;
  if (queue?.storageStatus === 'unavailable') {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        <AlertTitle>{t('operation.storage_unavailable_title')}</AlertTitle>
        <Typography>{t('operation.storage_unavailable_message')}</Typography>
        <Button onClick={() => window.location.reload()} sx={{ mt: 1 }}>
          {t('operation.storage_check_again')}
        </Button>
      </Alert>
    );
  }
  return (
    <Box
      role="status"
      sx={{
        display: 'flex', alignItems: 'center', gap: 2, my: 2,
      }}
    >
      <CircularProgress size={24} />
      <Typography>{t('operation.storage_checking')}</Typography>
    </Box>
  );
}
